import React from 'react';
import { Helmet } from 'react-helmet-async';

const PaymentSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Secure Payment | Airport Parking Deals",
    "description": "Complete your secure payment for airport parking. Fast checkout with encrypted payment processing and instant confirmation.",
    "url": "https://airportparkingdeals.co.uk/payment",
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://airportparkingdeals.co.uk"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Search",
          "item": "https://airportparkingdeals.co.uk/search"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "Booking",
          "item": "https://airportparkingdeals.co.uk/booking"
        },
        {
          "@type": "ListItem",
          "position": 4,
          "name": "Payment",
          "item": "https://airportparkingdeals.co.uk/payment"
        }
      ]
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default PaymentSchema;

